import {
  CreateCommonEntity,
  CommonEntity,
} from '@/pages/privatePages/common/types';
import { BaseService } from './base.service';
import APIService from './axios.service';

class CommonServiceClass extends BaseService<
  'common',
  CommonEntity,
  CreateCommonEntity
> {
  constructor() {
    super('common');
  }

  getPresignedUrls = (payload: {
    paths: string[];
  }): Promise<{ url: string }[]> => {
    return APIService.post(this.path + '/get-presigned-urls', payload);
  };
}
export const commonService = new CommonServiceClass();
